import { queryOptions } from "@tanstack/react-query"
import { GatedReceiptFailReason } from "ipctg-inflow-types/InFlowEnums"
import { GatedReceiptPOSTRequest } from "ipctg-inflow-types/InFlowGatedAPI"

import api from "@/utilities/api"

import { GatedReceiptError, GatedThemeError } from "@/utilities/expectedErrors"

import { RECEIPT_BASE_KEY, SHARED_BASE_KEY, THEME_BASE_KEY } from "./keys"

export const receiptQueryOptions = (args: GatedReceiptPOSTRequest) => {
  return queryOptions({
    queryKey: [SHARED_BASE_KEY, RECEIPT_BASE_KEY, args],
    queryFn: async () => {
      const rsp = await api.receipt.POST({ receiptID: args.receiptID })
      if ("failReason" in rsp) {
        throw new GatedReceiptError(rsp.failReason as GatedReceiptFailReason)
      }
      return rsp
    },
    retry: false,
  })
}

export const themeQueryOptions = (args: { qrLookupID: string | null }) => {
  return queryOptions({
    queryKey: [SHARED_BASE_KEY, THEME_BASE_KEY, args.qrLookupID],
    staleTime: Infinity,
    retry: false,
    queryFn: async () => {
      if (!args.qrLookupID) return null

      const rsp = await api.theme.POST({ qrLookupID: args.qrLookupID })

      if ("failReason" in rsp) {
        throw new GatedThemeError(rsp.failReason)
      }

      return rsp.theme
    },
  })
}
